import React from 'react';
import "./c84_course_director.scss";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { insertHtml } from "../../utils/dom";
import { isMobileOnly } from 'react-device-detect'

const CourseDirector = (props) => {
    return <div id="courseDirector" className="container-fluid">
        <div className="title">{props.data.title}</div>
        {props.data.subtitle && <div className="subtitle">{props.data.subtitle}</div>}
        {!isMobileOnly ?
            <div className="card-frame">
                <div className="left-side">
                    <div className="image-container">
                        <img src={props.data.image} alt={props.data.name} />
                    </div>
                </div>
                <div className="right-side">
                    <div className="name">{props.data.name}</div>
                    <div className="bios" {...insertHtml(props.data.bios)} />
                    <div className="contact">{props.data.contact_label}</div>
                    <div className="mail-contact">{props.data.email}</div>
                </div>
            </div>
            : <div className="card-frame-mob">
                <div className="left-side">
                    <div className="image-container">
                        <img src={props.data.image} alt={props.data.name} />
                    </div>
                </div>
                <div className="right-side">
                    <div className="name">{props.data.name}</div>
                    <div className="bios" {...insertHtml(props.data.bios)} />
                    <div className="contact">{props.data.contact_label}</div>
                    <div className="mail-contact">{props.data.email}</div>
                </div>
            </div>}
    </div>;
};

class C84CourseDirector extends TemplateComponent {
    componentRender(data) {
        return (
            <CourseDirector data={data} lang={this.props.language} />
        )
    }
}

export default C84CourseDirector;
